import { createResourceKeys } from "@/lib/resource-context";

export const capabilitiesKeys = createResourceKeys("capabilities");
